import { useSnack } from '../../../../context/snackBar';
import { GET_HELP_SECTIONS_LIST_QUERY_KEY } from '../../../../services/helpSections/getList';
import { useUpdateHelpSection } from '../../../../services/helpSections/update';
import {
  APIHelpSection,
  APIHelpSections,
  UpdateHelpSectionParams
} from '@partnerconnect-monorepo/types/HelpSection';
import { useForm } from 'react-hook-form';
import { t } from '@transifex/native';
import { useQueryClient } from '@tanstack/react-query';

export const useHelpSectionEditForm = (
  helpSection: APIHelpSection,
  closeForm: () => void
) => {
  const snack = useSnack();
  const queryClient = useQueryClient();

  const { control, handleSubmit, reset } = useForm<UpdateHelpSectionParams>({
    defaultValues: { title: helpSection.title, body: helpSection.body }
  });

  const onCancel = () => {
    closeForm();
    reset();
  };

  const { mutate: updateHelpSection, isPending: isUpdatingHelpSection } =
    useUpdateHelpSection(helpSection.id, {
      onSuccess: (updatedHelpSection) => {
        snack.success(t('Help section updated successfully'));
        queryClient.setQueryData(
          [GET_HELP_SECTIONS_LIST_QUERY_KEY],
          (previous: APIHelpSections) => ({
            ...previous,
            sections: previous.sections.map((helpSection) =>
              helpSection.id === updatedHelpSection.id
                ? updatedHelpSection
                : helpSection
            )
          })
        );
        closeForm();
      },
      onError: () => snack.error(t('Updating help section failed'))
    });

  const onSubmit = (data: UpdateHelpSectionParams) => updateHelpSection(data);

  return {
    control,
    onCancel,
    onSubmit: handleSubmit(onSubmit),
    isLoading: isUpdatingHelpSection
  };
};
